import React from 'react';
import {withTranslation} from "react-i18next";
import {Link} from "react-router-dom";

let RewardClaimComponent = ({orderDate, voucherAmount, id, t}) => {
    let date = new Date(orderDate);
    return (

        <Link to={'/order/' + id} className='claimLink'>
			<div className="ghost-btn claim-history-entry">
                <div className="row ">
                    <div className="col-3 text-center">
                        <div>{date.getDate()}</div>
                        <div>{t('months.' + date.getMonth())}</div>
                    </div>
                   <div className="col-6 align-self-center text-center">
                          {t('reward.claim.history.amount', {numberOfVouchers: voucherAmount})}
                   </div>
                    <div className="col-3 align-self-center text-center">
                        <span className="arrow-right"/>
                    </div>
                </div>
			</div>
        </Link>

	);


};

export default withTranslation() (RewardClaimComponent)